<div class="kl-loading-bar">
  <div class="kl-loading-bar__progress" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="{width: progress + '%'}">
    <span class="vl-u-visually-hidden">{{ progress }}% volledig</span>
  </div>
</div>